/**
 * Display-label helpers for taxonomy values.
 */

/**
 * Render a hyphenated, lowercase taxonomy value (e.g. use-case canonicals like
 * "defensive-handgun", "bulk-storage") in sentence case for display (#112):
 * hyphens/underscores become spaces and only the first letter is capitalized
 * ("Defensive handgun", "Bulk storage").
 *
 * @param {string} value
 * @returns {string}
 */
export function toSentenceCase(value: string): string {
  const spaced = value.replace(/[-_]+/g, ' ').trim();
  if (!spaced) return spaced;
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
